export default __webpack_public_path__ + "media/zurb/img/events/speaking/speaking-prezo-screenshot-d1ff0bf38675e8941c773cfada8dd51b.png";